export default __webpack_public_path__ + "static/media/maestro.47a66ea9.svg";